const ErrorCodes = {
    // General errors
    APPLICATION: 'APPLICATION',
    GENERAL_COMMUNICATION: 'GENERAL_COMMUNICATION',

    // Writer config file
    WRITERCONFIG_BAD_REQUEST: 'WRITERCONFIG_BAD_REQUEST',
    WRITERCONFIG_INTERNAL_SERVER_ERROR: 'WRITERCONFIG_INTERNAL_SERVER_ERROR',
    WRITERCONFIG_CLIENT_ERROR: 'WRITERCONFIG_CLIENT_ERROR',

    // Article
    ARTICLE_BAD_REQUEST: 'ARTICLE_BAD_REQUEST',
    ARTICLE_UNAUTHORIZED: 'ARTICLE_UNAUTHORIZED',
    ARTICLE_FORBIDDEN: 'ARTICLE_FORBIDDEN',
    ARTICLE_NOT_FOUND: 'ARTICLE_NOT_FOUND',
    ARTICLE_WRONG_FORMAT: 'ARTICLE_WRONG_FORMAT'
}

export {ErrorCodes}
